import { Spin, Table } from 'antd';
import { isEmpty } from 'lodash';
import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import BookingApi from '../../functions/api/booking/BookingApi';
import TableUtils from '../../functions/TableUtils';
interface Booking {
  cstm_name: string;
  bookingAcceptance: any[] | [];
  cstm_phon: string;
  cstm_emai: string;
}

function ListBookingCancel(props: any) {
  const [listBookingCancel, setListBookingCancel] = useState([]);

  useEffect(() => {
    getListBookingCancel();
  }, []);

  async function getListBookingCancel() {
    const listBookingCancel = await BookingApi.getBookingCancel();
    setListBookingCancel(listBookingCancel);
  }

  const renderAcceptStatus = (cell: any, row: any) => {
    const reason = row.bookingAcceptance[row.bookingAcceptance.length - 1];
    if (isEmpty(reason)) {
      return 'Lí do khác...';
    }

    return <span>{reason.reason}</span>;
  };

  const renderCustomerInfo = (cell: any, row: Booking) => {
    return (
      <React.Fragment>
        <div className="mb-2">
          <strong>{row.cstm_name}</strong>
        </div>
        <div>{row.cstm_phon}</div>
        <div>{row.cstm_emai}</div>
      </React.Fragment>
    );
  };

  const getColumnDropDownFilterReason = (dataIndex: any) => {
    if (!dataIndex) {
      return null;
    }

    const reasons = listBookingCancel.map((b: Booking) => {
      const finalData = b.bookingAcceptance[b.bookingAcceptance.length - 1];
      return finalData[dataIndex];
    });

    const filters = reasons
      .filter((option, index, all) => all.indexOf(option) === index)
      .filter((o) => !isEmpty(o))
      .map((o) => ({
        text: o,
        value: o,
      }));

    return {
      filters,
      onFilter: (value: any, record: Booking) => {
        const finalData =
          record.bookingAcceptance[record.bookingAcceptance.length - 1];
        return finalData[dataIndex] === value;
      },
    };
  };
  const columCancelBooking = [
    {
      title: 'Mã booking',
      dataIndex: 'book_code',
      key: 'book_code',
      width: '20%',
    },
    {
      title: 'Tên khách hàng',
      dataIndex: 'cstm_name',
      key: 'cstm_name',
      render: renderCustomerInfo,
      ...TableUtils.getColumnSearchProps('cstm_name'),
      onFilter(value: any, record: any) {
        if (!record['cstm_name'] && !record['cstm_phon']) {
          return false;
        }

        return (
          record['cstm_name']
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase()) ||
          record['cstm_phon']
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        );
      },
    },
    {
      title: 'Tên đối tác huỷ',
      dataIndex: 'part_name',
      key: 'part_name',
      ...TableUtils.getColumnSearchProps('part_name'),
    },
    {
      title: 'Lí do huỷ',

      dataIndex: ['bookingAcceptance'],
      key: 'bookingAcceptance',
      render: renderAcceptStatus,
      ...getColumnDropDownFilterReason('reason'),
    },
  ];

  if (isEmpty(listBookingCancel)) {
    return <Spin />;
  }

  return (
    <>
      <div className="content">
        <Table
          rowKey="book_id"
          size="small"
          columns={columCancelBooking}
          dataSource={listBookingCancel}
          scroll={{ x: 'max-content' }}
        />
      </div>
    </>
  );
}

export default withRouter(ListBookingCancel);
